import * as React from "react";
import * as ReactDOM from "react-dom";
import { MediaQuery } from "react-responsive";
import { Anchor } from "../../typography/anchor/anchor.mjs";
import { Icon } from "../../icon/icon/icon.mjs";
import { ThemeContext } from "../../helpers/theme-provider/theme-provider.mjs";
import { SidemenuContext } from "../sidemenu/sidemenu-context.mjs";
import { SidemenuNav } from "../sidemenu-nav/sidemenu-nav.mjs";
const _SidemenuItem = class _SidemenuItem extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = (event) => {
      event.preventDefault();
      if (this.props.onToggle) {
        this.props.onToggle(this.props);
      }
      if (this.props.onClick) {
        this.props.onClick(event);
      }
    };
    this.state = {
      isMounted: false
    };
  }
  get breakpoint() {
    return this.context.media.width.sm.min;
  }
  componentDidMount() {
    this.setState({
      isMounted: true
    });
  }
  BEM() {
    const classArray = ["sidemenu__item"];
    if (this.props.color) {
      classArray.push("sidemenu__item--" + this.props.color);
    }
    if (this.props.children) {
      classArray.push("sidemenu__item--has-children");
    }
    if (this.props.current || this.props.children && this.props.open) {
      classArray.push("is-current");
    }
    return classArray.join(" ");
  }
  renderSubnav() {
    if (!this.props.children) {
      return null;
    }
    return /* @__PURE__ */ React.createElement(SidemenuContext.Consumer, null, (context) => /* @__PURE__ */ React.createElement(
      SidemenuNav,
      {
        defaultTree: this.props.children,
        behaviour: context.behaviour,
        open: this.props.open,
        level: this.props.level ? this.props.level + 1 : 1
      }
    ));
  }
  renderIcon() {
    const icon = this.props.children ? "#arrow-down" : "#arrow-right";
    return /* @__PURE__ */ React.createElement(Icon, { modifiers: icon, className: "sidemenu__icon" });
  }
  renderDynamicSubnav() {
    return /* @__PURE__ */ React.createElement(MediaQuery, { minWidth: this.breakpoint }, (matches) => matches ? this.renderSubnav() : this.props.subContainer && ReactDOM.createPortal(this.renderSubnav(), this.props.subContainer));
  }
  render() {
    return /* @__PURE__ */ React.createElement(SidemenuContext.Consumer, null, (context) => /* @__PURE__ */ React.createElement("li", { className: this.BEM(), id: this.props.id, role: context.behaviour === "tabs" ? "presentation" : void 0 }, /* @__PURE__ */ React.createElement(
      Anchor,
      {
        url: this.props.url,
        className: "sidemenu__link",
        onClick: this.handleClick,
        isUnderlined: false,
        role: this.props.role,
        tabIndex: this.props.tabIndex,
        "aria-selected": this.props["aria-selected"]
      },
      this.props.label,
      this.renderIcon()
    ), this.props.children && (this.state.isMounted ? this.renderDynamicSubnav() : this.renderSubnav())));
  }
};
_SidemenuItem.contextType = ThemeContext;
let SidemenuItem = _SidemenuItem;
export {
  SidemenuItem
};
